
import { useCallback } from 'react'
import { Icon } from '@/components/ui/icon'
import { cn } from '@/lib/utils'
import type { AiModelPurpose } from '@genieartinc/schemas'
import type { IconName } from '@/components/ui/icon'

const PURPOSE_CONFIG: { value: AiModelPurpose; label: string; icon: IconName }[] = [
  { value: 'create', label: 'Create', icon: 'sparkles' },
  { value: 'edit', label: 'Edit', icon: 'pen-tool' },
  { value: 'enhance', label: 'Enhance', icon: 'wand-2' },
]

interface PurposeTabsProps {
  activePurpose: AiModelPurpose
  onPurposeChange: (purpose: AiModelPurpose) => void
}

export function PurposeTabs({ activePurpose, onPurposeChange }: PurposeTabsProps) {
  const handleClick = useCallback(
    (purpose: AiModelPurpose) => {
      if (purpose !== activePurpose) {
        onPurposeChange(purpose)
      }
    },
    [activePurpose, onPurposeChange]
  )

  // Tool nodes are created from the toolbar with purpose pre-set — no tab switching needed
  if (activePurpose === 'tools') return null

  return (
    <div className="border-b border-border px-3 py-3">
      <div className="flex gap-1">
        {PURPOSE_CONFIG.map(({ value, label, icon }) => (
          <button
            key={value}
            type="button"
            onClick={() => handleClick(value)}
            className={cn(
              'flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition-colors',
              value === activePurpose
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground'
            )}
          >
            <Icon name={icon} className="h-3.5 w-3.5" />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
